// Lib
import { isObject, padStart } from 'lodash';
import { TimeFormat, DEFAULT_TIME_FORMAT, TIME_FORMAT_12H } from '../../users/timeFormatConstants';

/**
 * Returns formatted time string based on the specified format.
 * 
 * For 12h format: "9am" or "9:30pm"
 * For 24h format: "09:00" or "09:30"
 * 
 * @param datetime - Date object, timestamp, or date string
 * @param format - Time format ('12h' or '24h'), defaults to '24h'
 */
export default (datetime: Date | string | number, format: TimeFormat = DEFAULT_TIME_FORMAT): string => {
    const testTime: Date = isObject(datetime) ? datetime : new Date(datetime);

    const hours24 = testTime.getHours();
    const minutes = testTime.getMinutes();
    const paddedMinutes = padStart(minutes.toString(), 2, '0');

    if (format === TIME_FORMAT_12H) {
        const hours12 = hours24 > 12 ? hours24 - 12 : hours24 || 12;
        const meridiem = hours24 > 11 ? 'pm' : 'am';
        return `${hours12}${minutes > 0 ? `:${paddedMinutes}` : ''}${meridiem}`;
    }

    // 24h format
    const paddedHours = padStart(hours24.toString(), 2, '0');
    return `${paddedHours}:${paddedMinutes}`;
};
